import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../components/button";

const AddUserModal = ({ isAddUserOpen, closeAddUserModal }) => {
  const [text, setText] = useState("");
  const [img, setImg] = useState("");
  return (
    <Modal show={isAddUserOpen} onHide={closeAddUserModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add New User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          
          <Button text="Add User" callBack={closeAddUserModal} />
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button text="Close" callBack={closeAddUserModal} />
        <Button text="Save Changes" callBack={closeAddUserModal} />
      </Modal.Footer>
    </Modal>
  );
};

export default AddUserModal;
